import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["burdenRate", "total"];

  connect() {
    this.calculateTotal();
  }

  calculateTotal() {
    const total = this.burdenRateTargets.reduce((acc, input) => {
      return acc + (parseFloat(input.value) || 0);
    }, 0);

    this.totalTarget.textContent = total;
  }
}
